module.exports = __webpack_public_path__ + "media/images/mailer/thumb_384-ae2cce5e42e6d88323e62bbd40b3dd24.jpg";